import { useState, useMemo, useRef, useImperativeHandle, forwardRef } from "react";

const InputSelect = forwardRef(({ elementi, onSelect }, ref) => {
  const [valore, setValore] = useState("");
  const listaRef = useRef(null);

  // Filtra la lista in base al testo
  const filtrati = useMemo(() => {
    if (!valore.trim()) return [...elementi].sort((a, b) => a.localeCompare(b));
    return elementi
      .filter((g) => g.toLowerCase().includes(valore.toLowerCase()))
      .sort((a, b) => a.localeCompare(b));
  }, [valore, elementi]);

  // Lettere presenti nei risultati
  const letterePresenti = useMemo(() => {
    const set = new Set(filtrati.map((n) => n[0].toUpperCase()));
    return Array.from(set).sort();
  }, [filtrati]);

  const handleChange = (e) => setValore(e.target.value);

  const handleSelect = (nome) => {
    setValore(nome);
    if (onSelect) onSelect(nome);
  };

  const scrollToLetter = (lettera) => {
    if (!listaRef.current) return;
    const elemento = listaRef.current.querySelector(`[data-lettera="${lettera}"]`);
    if (elemento) elemento.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const clearInput = () => {
    setValore("");
    if (onSelect) onSelect("");
  };

  // Espone metodi pubblici al parent
  useImperativeHandle(ref, () => ({
    reset: () => clearInput(),
    setValue: (v) => setValore(v),
    getValue: () => valore
  }));

  return (
    <div
      className="input-select"
      style={{
        position: "relative",
        width: "300px",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      {/* Input con pulsante X */}
      <div style={{ position: "relative", width: "100%" }}>
        <input
          type="text"
          value={valore}
          onChange={handleChange}
          placeholder="Cerca..."
          className="input"
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "8px 30px 8px 8px",
            backgroundColor: "white",
            color: "black",
            cursor: "initial",
            marginBottom: 0,
          }}
        />

        {valore && (
          <button
            type="button"
            onClick={clearInput}
            style={{
              position: "absolute",
              right: "5px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              fontWeight: "bold",
              fontSize: "2rem",
              color: "#666",
              cursor: "pointer",
              padding: "2px 6px",
            }}
          >
            ×
          </button>
        )}
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          marginTop: "5px",
        }}
      >
        {/* Lista nomi */}
        <ul
          ref={listaRef}
          style={{
            boxSizing: "border-box",
            background: "white",
            border: "1px solid #ccc",
            listStyle: "none",
            margin: 0,
            padding: 0,
            borderTopLeftRadius: 15,
            borderBottomLeftRadius: 15,
            width: "100%",
            height: "300px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          {filtrati.map((nome, index) => {
            const lettera = nome[0].toUpperCase();
            const prevLetter =
              index > 0 ? filtrati[index - 1][0].toUpperCase() : null;
            const mostraEtichetta = lettera !== prevLetter;

            return (
              <li
                key={nome}
                data-lettera={mostraEtichetta ? lettera : undefined}
                onClick={() => handleSelect(nome)}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                {mostraEtichetta && (
                  <div
                    style={{
                      fontWeight: "bold",
                      background: "#f0f0f0",
                      borderRadius: 5,
                      marginBottom: 10,
                      padding: "4px 6px",
                    }}
                  >
                    {lettera}
                  </div>
                )}
                {nome}
              </li>
            );
          })}
        </ul>

        {/* Colonna lettere */}
        <div
          style={{
            width: "40px",
            boxSizing: "border-box",
            border: "1px solid #ccc",
            background: "#fafafa",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflowY: "auto",
            height: "300px",
            fontSize: "0.9rem",
            userSelect: "none",
          }}
        >
          {letterePresenti.map((l) => (
            <div
              key={l}
              onClick={() => scrollToLetter(l)}
              style={{
                padding: "3px 0",
                cursor: "pointer",
              }}
            >
              {l}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default InputSelect;
